export enum OfferContactType {
    Vendor,
    Purchaser
}